export const EMOTION_STATUSES = [
  {
    id: 1,
    text: "とても気分がいい",
  },
  {
    id: 2,
    text: "少し気分がいい",
  },
  {
    id: 3,
    text: "普通",
  },
  {
    id: 4,
    text: "少し気分が悪い",
  },
  {
    id: 5,
    text: "とても気分が悪い",
  },
];
